import React, { useContext } from "react"

import { MissingContextError } from "shared/types/error/MissingContextError"

export interface SharedProjectContextType {
  projectShareID: string
}

export const SharedProjectContext =
  React.createContext<SharedProjectContextType | null>(null)

export function useSharedProjectContext() {
  const context = useContext(SharedProjectContext)
  if (!context) {
    throw new MissingContextError("Missing Context: SharedProjectContext")
  }
  return context
}
